import { Icon } from '@/common/components/Icon'
import { Button, Modal } from '@/components/ui'
import { cn } from '@/lib/utils'

interface RemoveStaffModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => void
  staffName?: string
}

export const RemoveStaffModal = ({
  open,
  onOpenChange,
  onConfirm,
  staffName,
}: RemoveStaffModalProps) => {
  const handleConfirm = () => {
    onConfirm()
    onOpenChange(false)
  }

  return (
    <Modal
      size="sm"
      open={open}
      onOpenChange={onOpenChange}
      headerClassName="mb-[37px]"
      contentClassName="p-0 border-2 border-monochrome-120"
      title={
        <div className="flex items-center gap-2.5">
          <div
            className={cn(
              'h-[44px] w-[44px] rounded-full',
              'bg-monochrome-5 backdrop-blur-md',
              'border-2 border-monochrome-120',
              'flex items-center justify-center',
              'shadow-[0_12px_40px_rgba(0,0,0,0.45)]',
            )}
          >
            <div
              className={cn(
                'h-[40px] w-[40px] rounded-full',
                'shadow-[0_0_24px_rgba(136,100%,51%,0.35)]',
                'flex items-center justify-center',
                'text-accent-1',
              )}
            >
              <Icon
                icon="profile-delete"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              />
            </div>
          </div>
          <h2 className="text-title-xxs text-monochrome-1 font-bold">
            Remove Staff
          </h2>
        </div>
      }
      footerClassName="mt-0 border-t border-monochrome-120 pt-[25px] mt-[25px]"
      footer={
        <div className="flex w-full items-center gap-[15px] justify-end">
          <Button
            onClick={() => onOpenChange(false)}
            variant="secondary"
            className="w-full"
          >
            No
          </Button>
          <Button
            onClick={handleConfirm}
            variant="destructive"
            className="w-full"
          >
            Yes, Remove
            <Icon
              icon="close-circle"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              className="shrink-0"
            />
          </Button>
        </div>
      }
    >
      <div className="text-monochrome-1 text-title-xxs">
        Are you sure you want to remove{' '}
        {staffName && (
          <>
            "<span className="text-accent-3">{staffName}</span>"
          </>
        )}
        ?
      </div>
    </Modal>
  )
}
